import { selector } from "recoil";

import { RideCrudModeKey } from "../../constants/rides.const";
import {
  buildRouteColorIdMatchesMap,
  collectPaletteRideIds,
  toStableRouteColorIdMatchesMap,
} from "../../helpers/ride/rides.map-colors-assignment.helpers";
import { routeColorIdMatchesAtom } from "../atoms";
import { selectedAndExpandedIdsSF } from "./table-layout.selectors";

/** Selected + expanded rows from rides grid and live map (`ride` / `rideMap`), sorted by ride id. */
export const paletteRideIdsForMapColorsSelector = selector<number[]>({
  key: "paletteRideIdsForMapColorsSelector",
  get: ({ get }) => {
    const mainRidesGridSelectedAndExpandedIds = get(
      selectedAndExpandedIdsSF(RideCrudModeKey.uiUnit),
    );
    const liveMapSelectedAndExpandedIds = get(
      selectedAndExpandedIdsSF("rideMap"),
    );
    return collectPaletteRideIds([
      ...mainRidesGridSelectedAndExpandedIds,
      ...liveMapSelectedAndExpandedIds,
    ]);
  },
});

/**
 * Single source of truth for palette indices: built synchronously (no default-green flash).
 * `useMapColorsService` only persists this map into `routeColorIdMatchesAtom` for sticky reuse.
 */
export const routeColorIdMatchesResolvedSelector = selector<
  Map<number, number>
>({
  key: "routeColorIdMatchesResolvedSelector",
  get: ({ get }) => {
    const rideIds = get(paletteRideIdsForMapColorsSelector);
    const prevMap = get(routeColorIdMatchesAtom);
    const builtMap = buildRouteColorIdMatchesMap({ rideIds, prevMap });
    return toStableRouteColorIdMatchesMap(builtMap);
  },
});
